import { render, staticRenderFns } from "./shipped.vue?vue&type=template&id=17c81cf4&"
import script from "./shipped.vue?vue&type=script&lang=js&"
export * from "./shipped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports